export const state = {
    catalogs: JSON.parse(localStorage.getItem('catalogs')) || {}
}

export default {
    ...state
}
